export default {
	infoBox: {
		description: 'Seller has paid to promote their vehicle, confirming their intent to sell. See {FAQ}.',
		faqs: 'FAQs',
		title: 'Paid Listing',
	},
	infoIconTitle: 'Paid Listing',
};
